var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-6"},[_c('em',[_vm._v(_vm._s(_vm.$t('components.materialTemplate.createModal.notImplemented')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }